import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spin } from 'antd';
import AuthService from '../../services/authService';

const KakaoCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const called = useRef(false);

    useEffect(() => {
        if (called.current) return;
        called.current = true;

        const code = searchParams.get('code');
        if (!code) {
            navigate('/login', { replace: true });
            return;
        }

        (async () => {
            try {
                const redirectUri = `${window.location.origin}/auth/kakao/callback`;
                const res = await AuthService.loginWithKakao(code, redirectUri);
                if (res) {
                    navigate('/', { replace: true });
                } else {
                    navigate('/login', {
                        replace: true,
                        state: { error: '카카오 로그인에 실패했습니다.' },
                    });
                }
            } catch (err) {
                const msg =
                    err.response?.data?.message || err.message || '카카오 로그인에 실패했습니다.';
                navigate('/login', { replace: true, state: { error: msg } });
            }
        })();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                flexDirection: 'column',
                gap: 16,
            }}
        >
            <Spin size="large" />
            <p style={{ color: '#555', marginTop: 12 }}>카카오 로그인 처리 중...</p>
        </div>
    );
};

export default KakaoCallback;
